import * as React from 'react';
import ModelItem from "./ModelItem";

function ModelsCollection(props){
    const collection = props.models.map((item, index) =>
        <React.Fragment key={index}>
            <ModelItem
                dataProvider={item}
                onModelClick={() => props.onModelClick(item)}
            />
        </React.Fragment>
    );

    return (
        <div id='modelsContainer'>
            {collection}
        </div>
    );
}

export default ModelsCollection;
